import { Constant } from './Constant';

export default class Config {
    static API_URL = Constant.API_URL;
    static API_BASE_URL = Constant.API_BASE_URL;
    static ROWS_PER_PAGE = Constant.ROWS_PER_PAGE;
    // static USERNAME = Constant.USERNAME;
    // static PASSWORD = Constant.PASSWORD;
    // static CREDENTIALS = btoa(`${Config.USERNAME}:${Config.PASSWORD}`);
}

Object.freeze(Config);

export const reactDataTableCustomStyles = {
    headRow: {
        style: {
            border: 'none'
        }
    },
    headCells: {
        style: {
            color: '#202124',
            fontSize: '14px'
        }
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF'
        }
    },
    columns: {
        name: {}
    },
    pagination: {
        style: {
            border: 'none'
        }
    }
};

export const miniCardJson = {
    title: 'Approved',
    amount: '',
    totalAmount: '',
    iconName: 'icon-check-circle',
    currency: '',
    percentage: '',
    classNames: 'theme-bg'
};
export const attempted = {
    title: 'Attempted',
    amount: '',
    totalAmount: '',
    iconName: 'icon-check-circle',
    currency: '',
    percentage: '',
    classNames: 'theme-bg'
};
export const rejected = {
    title: 'Rejected',
    amount: '',
    totalAmount: '',
    iconName: 'icon-alert-triangle',
    currency: '',
    percentage: '',
    classNames: 'theme-bg4'
};
export const evaluated = {
    title: 'Evaluated',
    amount: '',
    totalAmount: '',
    iconName: 'icon-clipboard',
    currency: '',
    percentage: '',
    classNames: 'theme-bg2'
};
export const pending = {
    title: 'Pending',
    amount: '',
    totalAmount: '',
    iconName: 'icon-bookmark',
    currency: '',
    percentage: '',
    classNames: 'theme-bg5'
};
export const Approved_with_changes = {
    title: 'Approved with changes',
    amount: '',
    totalAmount: '',
    iconName: 'icon-check',
    currency: '',
    percentage: '',
    classNames: 'theme-bg'
};
export const Red_flagged = {
    title: 'Red flagged',
    amount: '',
    totalAmount: '',
    iconName: 'icon-alert-triangle',
    currency: '',
    percentage: '',
    classNames: 'theme-bg4'
};

export const rolesMapping = {
    admin: {
        allowedActions: ['dashboard', 'user', 'order', 'coupons', 'transaction', 'messages'],
        canCreateRoles: ['auditor', 'supervisor', 'qc', 'qc_manager', 'project_manager', 'business_analyst', 'reporter']
    }
};

// export const orderStatus = [
//     { label: 'Created', value: 'created' },
//     { label: 'Payment pending', value: 'payment_pending' },
//     { label: 'Initiated', value: 'initiated' },
//     { label: 'Package received', value: 'package_received' },
//     { label: 'Towards destination', value: 'towards_destination' },
//     { label: 'Package delivered', value: 'package_delivered' },
//     { label: 'Disputed', value: 'disputed' },
//     { label: 'Completed', value: 'completed' },
//     { label: 'Blocked', value: 'blocked' },
//     { label: 'Deleted', value: 'deleted' }
// ];
export const orderStatus = [
    { label: 'Created', value: 'created', background: 'theme-bg5', color: 'white' },
    { label: 'Payment pending', value: 'payment_pending', background: 'theme-bg5', color: 'white' },
    { label: 'Initiated', value: 'initiated', background: 'theme-bg7', color: 'white' },
    { label: 'Package received', value: 'package_received', background: 'theme-bg2', color: 'white' },
    { label: 'Towards destination', value: 'towards_destination', background: 'theme-bg5', color: 'white' },
    { label: 'Package delivered', value: 'package_delivered', background: 'theme-bg2', color: 'white' },
    { label: 'Disputed Resolved', value: 'disputed_resolved', background: 'theme-bg4', color: 'white' },
    { label: 'Completed', value: 'completed', background: 'theme-bg2', color: 'white' },
    { label: 'Blocked', value: 'blocked', background: 'theme-bg4', color: 'white' },
    { label: 'Package received by customer', value: 'package_received_by_customer', background: 'theme-bg4', color: 'white' }
];
export const orderFilterStatus = [
    { label: 'Created', value: 'created', background: '#D9EFFF', color: '#000' },
    { label: 'Payment pending', value: 'payment_pending', background: 'theme-bg5', color: '#000' },
    { label: 'Initiated', value: 'initiated', background: '#F5F5DC', color: '#000' },
    { label: 'Package received', value: 'package_received', background: '#C6E2FF', color: '#000' },
    { label: 'Towards destination', value: 'towards_destination', background: '#FFDAB9', color: '#000' },
    { label: 'Package delivered', value: 'package_delivered', background: '#DFF2BF', color: '#000' },
    { label: 'Disputed', value: 'disputed', background: '#FDD9B5', color: '#000' },
    { label: 'Completed', value: 'completed', background: 'theme-bg2', color: 'white' },
    { label: 'Blocked', value: 'blocked', background: 'theme-bg4', color: '#000' },
    { label: 'Package received by customer', value: 'package_received_by_customer', background: 'theme-bg4', color: 'black' }
];

export const departureCountryList = [
    { label: 'Côte d’Ivoire', value: 'Côte d’Ivoire' },
    { label: 'Bénin', value: 'Benin' },
    { label: 'Sénégal', value: 'Senegal' },
    { label: 'Cameroun', value: 'Cameroun' }
];

export const arrivalCountryList = [
    { label: 'Côte d’Ivoire', value: 'Côte d’Ivoire' },
    { label: 'Bénin', value: 'Benin' },
    { label: 'Sénégal', value: 'Senegal' },
    { label: 'Cameroun', value: 'Cameroun' },
    { label: 'Guyane', value: 'Guyane' },
    { label: 'Guadeloupe', value: 'Guadeloupe' },
    { label: 'Martinique', value: 'Martinique' },
    { label: 'La Réunion', value: 'La Réunion' }
];

export const userStatusList = [
    { label: 'Pending', value: 0 },
    { label: 'Verified', value: 1 },
    { label: 'Rejected', value: 2 }
];
export const userFilterList = [
    { label: 'Active', value: 0, category: 'active' },
    { label: 'InActive', value: 1, category: 'active' },
    { label: 'Pending', value: 0, category: 'verified' },
    { label: 'Verified', value: 1, category: 'verified' },
    { label: 'Rejected', value: 2, category: 'verified' }
];
export const transactionStatusList = [
    { label: 'Approved', value: 'approved' },
    { label: 'Rejected', value: 'rejected' }
];
export const transactionFilterList = [
    { label: 'Approved', value: 'approved' },
    { label: 'Rejected', value: 'rejected' },
    { label: 'Pending', value: 'pending' },
    { label: 'Truncated', value: 'truncated' }
];
export const rolesList = [
    { label: 'Auditor', value: 'auditor' },
    { label: 'Supervisor', value: 'supervisor' },
    { label: 'Qc', value: 'qc' },
    { label: 'Qc Manager', value: 'qc_manager' },
    { label: 'Project Manager', value: 'project_manager' },
    { label: 'Reporter', value: 'reporter' },
    { label: 'Business Analyst', value: 'business_analyst' }
];

//  admin: {
//         allowedActions: ['dashboard', 'users', 'settings'],
//         canCreateRoles: ['auditor', 'supervisor', 'qc', 'qc_manager', 'project_manager']
//     },

//  canCreateRoles: ['auditor', 'supervisor', 'qc', 'qc_manager', 'project_manager'];
// export const customStyles = {
//     singleValue: N() => ({
//         color: '#666 !important'
//     }),
//     indicatorSeparator: (provided) => ({
//         ...provided,
//         marginBottom: '2px !important',
//         marginTop: '2px !important'
//     }),
//     control: () => ({
//         border: 'none',
//         display: 'flex',
//         borderBottom: '1px solid #000',
//         fontWeight: 700,
//         fontStretch: 'normal',
//         fontStyle: 'normal',
//         lineHeight: '1.38',
//         letterSpacing: 'normal'
//     })
// };

// export const dataTableCustomStyles = {
//     headCells: {
//         style: {
//             fontFamily: 'HelvNeueOrange,Helvetica',
//             backgroundColor: '#f4f4f4',
//             color: '#000000',
//             fontSize: '16px',
//             fontWeight: 'bold'
//         }
//     },
//     cells: {
//         style: {
//             fontFamily: 'HelvNeueOrange,Helvetica',
//             fontSize: '16px',
//             color: '#000000'
//         }
//     }
// };
